<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0px;
}
/* #app {
  width: 100%;
  height: 100%;
}*/
body{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue